import services from './services';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import {
    GetERP_SendGoodsByPage,
    ERP_AuditSendGoods,
    GetSendGoodsAuditStatistics
} from '@api/sendGoodsApi';
import {
    GetOrderFinanceAuditByPage,
    ERP_AuditOrder,
    GetERP_OrderById
} from '@api/orderApi';
import NProgress from 'nprogress';
import {
    MAP_LIST
} from '$http';
import $http from '$http';

import voucherAuditDialog from '@pages/Order/voucherAudit/components/voucherAuditDialog/index.vue'; //凭证审核及其他审核弹窗
import paymentAuditOrder from './components/paymentAuditOrder/index.vue'; //合同款审核及查看弹窗
export default {
    mixins: [services],
    components: {
        voucherAuditDialog,
        paymentAuditOrder
    },
    data: function () {
        return {
            auditBtnShow: true,
            ssProjectList: [{
                id: 1,
                name: "联帮在线"
            }, {
                id: 2,
                name: "HI幼教"
            }, {
                id: 4,
                name: "智趣坞"
            }, {
                id: 128,
                name: "联帮会销"
            }],
            AuditNum: [],
            queryType: [{
                "TypeName": "-请选择-",
                "TypeValue": "-1"
            }, {
                "TypeName": "待审核",
                "TypeValue": "1"
            }, {
                "TypeName": "审核通过",
                "TypeValue": "6"
            }, {
                "TypeName": "凭证审核不通过",
                "TypeValue": "11"
            }, {
                "TypeName": "审核不通过",
                "TypeValue": "12"
            }],
            orderStateList: this.$store.state.orderStateMapList, //发货状态
            loading: false,
            lists: [],
            pageIndex: 1,
            pageSize: 10,
            totalSize: '',
            sels: [], //列表选中列
            SaleCheckView: false,
            pageSizes: [10, 20, 50],
            policyTypeName: "",
            query: this.getQuery()
        }
    },
    methods: {
        getQuery() {
            return cloneDeep({
                OrderCode: "",
                c_name: "",
                SendCode: "",
                AgentName: "",
                ProjectType: "",
                auditStartDate: "",
                auditEndDate: "",
                OrderStatus: "",
                AreaName: "",
                UserName: "",
                SendStatus: "",
            });
        },
        reLoadData() {
            this.pageIndex = 1;
            this.List();
        },

        //通用输入参数
        getParams() {
            var para = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                orderBy: this.orderBy
            };
            for (let item in this.query) {
                let value = this.query[item];
                if (value !== '') {
                    // 去除空格trimAllSpace(str, is_global)  true 为去除所有空格
                    if (typeof value == 'string') {
                        value = util.trimAllSpace(value);
                    }
                    this.query[item] = value
                    para[item] = value;
                    if (item == "auditStartDate" || item == "auditEndDate") {
                        para[item] = util.time2str(value);
                    }
                }
            }

            return para;
        },
        selsChange: function (sels) {
            this.sels = sels;
        },
        //查询
        onQuerySubmit: function () {
            this.pageIndex = 1;
            this.List();
        },
        //查询功能
        handleSizeChange: function (val) {
            this.pageSize = val;
            this.List();
        },
        //重置
        onQueryClean: function () {
            this.query = this.getQuery();
            this.List();
        },
        //查询单条
        handleView: function (index, row) {
            //VoucherType 1:合同款审核 2:凭证审核  3:其他审核
            if (row.VoucherType == 2 || row.VoucherType == 3 || row.VoucherType == 1) {
                this.$refs.refVoucherAuditDialog.show({
                    id: row.OrderId,
                    isReadOnly: true,
                    VoucherType: row.VoucherType
                });
            } else {
                this.$refs.refPaymentAuditOrder.show({
                    id: row.OrderId,
                    isReadOnly: true,
                    VoucherType: row.VoucherType
                });
            }

        },
        //审核
        adoptHandle: function (index, row) {
            //VoucherType 1:合同款审核 2:凭证审核  3:其他审核
            if (row.VoucherType == 2 || row.VoucherType == 3 || row.VoucherType == 1) {
                this.$refs.refVoucherAuditDialog.show({
                    id: row.OrderId,
                    isReadOnly: false,
                    VoucherType: row.VoucherType
                });
            } else {
                this.$refs.refPaymentAuditOrder.show({
                    id: row.OrderId,
                    isReadOnly: false,
                    VoucherType: row.VoucherType
                });
            }

        },
        //下载文件
        download: function () {
            this.$confirm('确认导出吗？', '提示', {}).then(() => {
                this.List();
                var para = this.getParams();
                //GET /api/Order/GetOrderFinanceAuditExport
                util.exportToFileV2("api/Order/GetOrderFinanceAuditExport", para, this);
            });
        },
        handleCurrentChange: function (val) {
            this.pageIndex = val;
            this.List();
            //this.onQueryClean();//重置搜索条件刷新2017/10/25
        },
    },
    watch: {
        '$route' (to, from) {
            this.showOrHideAuditBtn();
        }
    },
    created: function () {
        this.List();
    }

}


// WEBPACK FOOTER //
// ./src/pages/Order/voucherAudit/vm.js